import { render, staticRenderFns } from "./right_mimic.vue?vue&type=template&id=5327bd5a&scoped=true"
import script from "./right_mimic.vue?vue&type=script&lang=js"
export * from "./right_mimic.vue?vue&type=script&lang=js"
import style0 from "./right_mimic.vue?vue&type=style&index=0&id=5327bd5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5327bd5a",
  null
  
)

export default component.exports